
import ExampleTestModalComponent from "@/components/Modals/ExampleTestModal/ExampleTestModalComponent";
export default ExampleTestModalComponent;
